import React from 'react';
import styles from './MenuLink.module.scss';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';

class MenuLink extends React.PureComponent {
  constructor (props, context) {
    super(props, context);
    this.state = {
      open: false
    };
  }

  collapse = () => {
    this.setState({ open: false });
  }

  open = () => {
    this.setState({ open: true });
  }

  render () {
    const validUser = this.props.validUser || [];
    return <div className={classnames(styles.component)} onMouseEnter={this.open} onMouseLeave={this.collapse}>
      <div id='menu-header' className={classnames(styles.menuHeader, { [styles.active]: this.props.activeMenu === this.props.text })}>
        <div className={styles.header} onClick={this.collapse}>
          <span>{this.props.text}</span>
          {this.props.sublinks && <FaChevronDown className={classnames(styles.chevron, {
            [styles.chevronUp]: this.state.open
          })} />}
        </div></div>
      {(this.props.sublinks && this.state.open) && <div className={styles.dropdownContainer}><div className={styles.dropdown} onClick={this.collapse}>
        {this.props.sublinks.map(({ link, path, key, name }, i) =>
          <Link key={i} to={path}
            className={classnames(styles.link, { [styles.active]: this.props.activeLink === key, [styles.hide]: !validUser.includes(name) })}
            onClick={() => this.props.onMenuLinkClick(link)}>{link}</Link>
        )}
      </div></div>}
    </div>;
  }
}

MenuLink.propTypes = {
  text: PropTypes.string,
  onMenuLinkClick: PropTypes.func,
  activeLink: PropTypes.string,
  activeMenu: PropTypes.string,
  validUser: PropTypes.array,
  sublinks: PropTypes.array
};

export default MenuLink;
